import { isAxiosError } from "axios";
import { ERR_OUTDATED_CARGO_REVISION } from "dora-shared";

// The server refused a save because someone else saved the cargo (or cargo
// template) since the dialog loaded it (DORA-441).
export const isOutdatedRevisionError = (e: unknown) =>
  isAxiosError(e) &&
  e.response?.status === 409 &&
  e.response.data?.message === ERR_OUTDATED_CARGO_REVISION;
